import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Row, Col, Card, Table, Button, Input, Modal, Typography, Tag, Space,
  Drawer, Form, Select, notification
} from "antd";
import { DeleteOutlined, EditOutlined, ExclamationCircleOutlined, CloseOutlined, HomeOutlined } from "@ant-design/icons";
import axios from "axios";
import { baseUrl } from "../../config";

const { confirm } = Modal;
const { Search, TextArea } = Input;
const { Title, Text } = Typography;
const { Item } = Form;
const { Option } = Select;

function VillageList() {
  const history = useHistory();

  const [dataList, setDataList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit] = useState(10);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [editId, setEditId] = useState(null);
  const [saving, setSaving] = useState(false);
  const [form] = Form.useForm();

  const [drawerCountries, setDrawerCountries] = useState([]);
  const [drawerStates, setDrawerStates] = useState([]);
  const [drawerDistricts, setDrawerDistricts] = useState([]);
  const [drawerTehsils, setDrawerTehsils] = useState([]);
  const [drawerPanchayats, setDrawerPanchayats] = useState([]);

  const authHeader = { Authorization: `Bearer ${localStorage.getItem('accessToken')}` };

  useEffect(() => {
    axios.get(`${baseUrl}/pop-country/list-all`, { headers: authHeader })
      .then(r => { if (r.data.status) setDrawerCountries(r.data.result); });
  }, []);

  const fetchList = async (page = currentPage, searchVal = search) => {
    setLoading(true);
    try {
      const res = await axios.get(`${baseUrl}/pop-village`, {
        headers: authHeader,
        params: { page, limit, search: searchVal }
      });
      if (res.data.status) {
        setDataList(res.data.result.map((item, i) => ({ ...item, key: (page - 1) * limit + i + 1 })));
        setTotalCount(res.data.totalCount);
      }
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  };

  useEffect(() => { fetchList(); }, [currentPage]);

  const handleDelete = (id) => {
    confirm({
      title: 'Are you sure you want to delete this record?',
      icon: <ExclamationCircleOutlined />,
      okText: 'Yes, Delete', okType: 'danger', cancelText: 'Cancel',
      onOk: async () => {
        try {
          await axios.delete(`${baseUrl}/pop-village/${id}`, { headers: authHeader });
          notification.success({ message: 'Deleted successfully' });
          fetchList();
        } catch (err) { console.error(err); }
      }
    });
  };

  const openAdd = () => {
    form.resetFields();
    form.setFieldsValue({ status: '1' });
    setDrawerStates([]); setDrawerDistricts([]); setDrawerTehsils([]); setDrawerPanchayats([]);
    setEditId(null);
    setDrawerOpen(true);
  };

  const openEdit = async (record) => {
    setDrawerStates([]); setDrawerDistricts([]); setDrawerTehsils([]); setDrawerPanchayats([]);
    setEditId(record.id);
    setDrawerOpen(true);
    if (record.country_id) {
      const r = await axios.get(`${baseUrl}/pop-states/list-all`, { headers: authHeader, params: { country_id: record.country_id } });
      if (r.data.status) setDrawerStates(r.data.result);
    }
    if (record.state_id) {
      const r = await axios.get(`${baseUrl}/pop-districts/list-all`, { headers: authHeader, params: { state_id: record.state_id } });
      if (r.data.status) setDrawerDistricts(r.data.result);
    }
    if (record.district_id) {
      const r = await axios.get(`${baseUrl}/pop-tehsils/list-all`, { headers: authHeader, params: { district_id: record.district_id } });
      if (r.data.status) setDrawerTehsils(r.data.result);
    }
    if (record.tehsil_id) {
      const r = await axios.get(`${baseUrl}/pop-panchayat/list-all`, { headers: authHeader, params: { tehsil_id: record.tehsil_id } });
      if (r.data.status) setDrawerPanchayats(r.data.result);
    }
    form.setFieldsValue({
      country_id: record.country_id ? parseInt(record.country_id) : undefined,
      state_id: record.state_id ? parseInt(record.state_id) : undefined,
      district_id: record.district_id ? parseInt(record.district_id) : undefined,
      tehsil_id: record.tehsil_id ? parseInt(record.tehsil_id) : undefined,
      panchayat_id: record.panchayat_id ? parseInt(record.panchayat_id) : undefined,
      name: record.name,
      village_history: record.village_history || '',
      status: String(record.status)
    });
  };

  const onCountryChange = v => {
    form.setFieldsValue({ state_id: undefined, district_id: undefined, tehsil_id: undefined, panchayat_id: undefined });
    setDrawerStates([]); setDrawerDistricts([]); setDrawerTehsils([]); setDrawerPanchayats([]);
    if (v) axios.get(`${baseUrl}/pop-states/list-all`, { headers: authHeader, params: { country_id: v } })
      .then(r => { if (r.data.status) setDrawerStates(r.data.result); });
  };
  const onStateChange = v => {
    form.setFieldsValue({ district_id: undefined, tehsil_id: undefined, panchayat_id: undefined });
    setDrawerDistricts([]); setDrawerTehsils([]); setDrawerPanchayats([]);
    if (v) axios.get(`${baseUrl}/pop-districts/list-all`, { headers: authHeader, params: { state_id: v } })
      .then(r => { if (r.data.status) setDrawerDistricts(r.data.result); });
  };
  const onDistrictChange = v => {
    form.setFieldsValue({ tehsil_id: undefined, panchayat_id: undefined });
    setDrawerTehsils([]); setDrawerPanchayats([]);
    if (v) axios.get(`${baseUrl}/pop-tehsils/list-all`, { headers: authHeader, params: { district_id: v } })
      .then(r => { if (r.data.status) setDrawerTehsils(r.data.result); });
  };
  const onTehsilChange = v => {
    form.setFieldsValue({ panchayat_id: undefined });
    setDrawerPanchayats([]);
    if (v) axios.get(`${baseUrl}/pop-panchayat/list-all`, { headers: authHeader, params: { tehsil_id: v } })
      .then(r => { if (r.data.status) setDrawerPanchayats(r.data.result); });
  };

  const onSave = async (values) => {
    setSaving(true);
    try {
      if (editId) {
        await axios.put(`${baseUrl}/pop-village/${editId}`, values, { headers: authHeader });
      } else {
        await axios.post(`${baseUrl}/pop-village`, values, { headers: authHeader });
      }
      notification.success({ message: editId ? 'Village updated successfully' : 'Village added successfully' });
      setDrawerOpen(false);
      fetchList();
    } catch (err) {
      notification.error({ message: err.response?.data?.message || 'Error saving record' });
    } finally {
      setSaving(false);
    }
  };

  const columns = [
    { title: '#', dataIndex: 'key', key: 'key', width: 60 },
    { title: 'Village Name', dataIndex: 'name', key: 'name' },
    { title: 'Panchayat', dataIndex: 'panchayat_name', key: 'panchayat_name' },
    { title: 'Tehsil', dataIndex: 'tehsil_name', key: 'tehsil_name' },
    { title: 'District', dataIndex: 'district_name', key: 'district_name' },
    { title: 'Village History', dataIndex: 'village_history', key: 'village_history', ellipsis: true, width: 200 },
    {
      title: 'Status', dataIndex: 'status', key: 'status', width: 90,
      render: s => <Tag color={String(s) === '1' ? 'green' : 'red'}>{String(s) === '1' ? 'Active' : 'Inactive'}</Tag>
    },
    {
      title: 'Actions', key: 'actions', fixed: 'right', width: 140,
      render: (_, record) => (
        <Space size={4}>
          <Button size="small" icon={<EditOutlined />} onClick={() => openEdit(record)} style={{ background: '#7a0000', borderColor: '#7a0000', color: '#fff' }}>Edit</Button>
          <Button size="small" danger icon={<DeleteOutlined />} onClick={() => handleDelete(record.id)}>Delete</Button>
        </Space>
      )
    }
  ];

  return (
    <div className="tabled">
      <Row gutter={[24, 0]}>
        <Col span={24}>
          <Card
            title={<span style={{ color: '#1e293b', fontWeight: 700, fontSize: 15 }}>Village List</span>}
            headStyle={{ background: '#f8fafc', borderBottom: '1.5px solid #e2e8f0' }}
            extra={<Button onClick={openAdd} style={{ background: '#fff', borderColor: '#fff', color: '#7a0000', fontWeight: 600 }}>Add New Village</Button>}
          >
            <div style={{ marginBottom: 16 }}>
              <Search
                placeholder="Search village..."
                onSearch={val => { setSearch(val); setCurrentPage(1); fetchList(1, val); }}
                allowClear
                style={{ width: 300 }}
                enterButton={<Button style={{ background: '#7a0000', borderColor: '#7a0000', color: '#fff' }}>Search</Button>}
              />
            </div>
            <Table
              columns={columns}
              dataSource={dataList}
              loading={loading}
              pagination={{
                current: currentPage,
                pageSize: limit,
                total: totalCount,
                onChange: p => setCurrentPage(p),
                showTotal: t => `Total ${t} villages`
              }}
              scroll={{ x: 'max-content' }}
              size="small"
            />
          </Card>
        </Col>
      </Row>

      <Drawer
        title={
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div style={{ width: 40, height: 40, borderRadius: '50%', background: 'rgba(255,255,255,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <HomeOutlined style={{ color: 'white', fontSize: 18 }} />
            </div>
            <div>
              <div style={{ color: 'white', fontWeight: 600, fontSize: 15 }}>{editId ? 'Edit Village' : 'Add New Village'}</div>
              <div style={{ color: 'rgba(255,255,255,0.75)', fontSize: 12 }}>{editId ? 'Modify village details' : 'Create a new village entry'}</div>
            </div>
          </div>
        }
        width={560}
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        closable={false}
        headerStyle={{ background: '#f8fafc', borderBottom: '1.5px solid #e2e8f0' }}
        bodyStyle={{ padding: 0, background: '#f8f9fa' }}
        extra={
          <Button type="text" icon={<CloseOutlined />} onClick={() => setDrawerOpen(false)} style={{ color: 'white' }} />
        }
        destroyOnClose
      >
        <div style={{ padding: 24 }}>
          <Form form={form} layout="vertical" onFinish={onSave}>
            <div style={{ fontSize: 11, fontWeight: 700, color: '#8c8c8c', textTransform: 'uppercase', letterSpacing: '1.5px', marginBottom: 16, paddingBottom: 8, borderBottom: '1px solid #f0f0f0' }}>
              Location Hierarchy
            </div>
            <Row gutter={[16, 0]}>
              <Col xs={24} sm={12}>
                <Item name="country_id" label="Country" rules={[{ required: true, message: 'Required' }]}>
                  <Select placeholder="Select Country" showSearch optionFilterProp="children" onChange={onCountryChange} style={{ width: '100%' }}>
                    {drawerCountries.map(c => <Option key={c.id} value={c.id}>{c.name}</Option>)}
                  </Select>
                </Item>
              </Col>
              <Col xs={24} sm={12}>
                <Item name="state_id" label="State" rules={[{ required: true, message: 'Required' }]}>
                  <Select placeholder="Select State" showSearch optionFilterProp="children" onChange={onStateChange} disabled={drawerStates.length === 0} style={{ width: '100%' }}>
                    {drawerStates.map(s => <Option key={s.id} value={s.id}>{s.name}</Option>)}
                  </Select>
                </Item>
              </Col>
              <Col xs={24} sm={12}>
                <Item name="district_id" label="District" rules={[{ required: true, message: 'Required' }]}>
                  <Select placeholder="Select District" showSearch optionFilterProp="children" onChange={onDistrictChange} disabled={drawerDistricts.length === 0} style={{ width: '100%' }}>
                    {drawerDistricts.map(d => <Option key={d.id} value={d.id}>{d.name}</Option>)}
                  </Select>
                </Item>
              </Col>
              <Col xs={24} sm={12}>
                <Item name="tehsil_id" label="Tehsil" rules={[{ required: true, message: 'Required' }]}>
                  <Select placeholder="Select Tehsil" showSearch optionFilterProp="children" onChange={onTehsilChange} disabled={drawerTehsils.length === 0} style={{ width: '100%' }}>
                    {drawerTehsils.map(t => <Option key={t.id} value={t.id}>{t.name}</Option>)}
                  </Select>
                </Item>
              </Col>
              <Col xs={24}>
                <Item name="panchayat_id" label="Gram Panchayat" rules={[{ required: true, message: 'Required' }]}>
                  <Select placeholder="Select Panchayat" showSearch optionFilterProp="children" disabled={drawerPanchayats.length === 0} style={{ width: '100%' }}>
                    {drawerPanchayats.map(p => <Option key={p.id} value={p.id}>{p.name}</Option>)}
                  </Select>
                </Item>
              </Col>
            </Row>

            <div style={{ fontSize: 11, fontWeight: 700, color: '#8c8c8c', textTransform: 'uppercase', letterSpacing: '1.5px', marginBottom: 16, paddingBottom: 8, borderBottom: '1px solid #f0f0f0', marginTop: 8 }}>
              Village Details
            </div>
            <Row gutter={[16, 0]}>
              <Col xs={24} sm={12}>
                <Item name="name" label="Village Name" rules={[{ required: true, message: 'Required' }]}>
                  <Input placeholder="Enter village name" />
                </Item>
              </Col>
              <Col xs={24} sm={12}>
                <Item name="status" label="Status">
                  <Select>
                    <Option value="1">Active</Option>
                    <Option value="0">Inactive</Option>
                  </Select>
                </Item>
              </Col>
              <Col xs={24}>
                <Item name="village_history" label="Village History">
                  <TextArea rows={3} placeholder="Enter village history (optional)" />
                </Item>
              </Col>
            </Row>

            <div style={{ borderTop: '1px solid #f0f0f0', paddingTop: 20, display: 'flex', justifyContent: 'flex-end', gap: 12, marginTop: 8 }}>
              <Button onClick={() => setDrawerOpen(false)} style={{ borderRadius: 8 }}>Cancel</Button>
              <Button type="primary" htmlType="submit" loading={saving} style={{ background: '#7a0000', borderColor: '#7a0000', borderRadius: 8 }}>
                {editId ? 'Update Village' : 'Save Village'}
              </Button>
            </div>
          </Form>
        </div>
      </Drawer>
    </div>
  );
}

export default VillageList;
